<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { currency } from '@elements/number-formatter';
import { trans } from '@elements/translation';
import { useAccountStore } from '../store/account';
import { usePayoutsStore } from '../store/payouts';
import SimpleTable from '../general/SimpleTable.vue';
import CardEmptyTable from '../general/CardEmptyTable.vue';
import SimpleTableMobile from '../general/SimpleTableMobile.vue';
import { getAccountStatus } from '../helper/StripeHelper';
import EmptyCardManager from '../subscriptions/EmptyCardManager.vue';
import StripeSoonLimited from '../Onboarding/StripeSoonLimited';
import { STRIPE_LIMITED } from '../constants/constants';

const payoutStore = usePayoutsStore();
const accountStore = useAccountStore();

const headers = [
  { key: 'amount', title: trans('gestion.payout.amount') },
  { key: 'status', title: trans('gestion.payout.status'), transPrefix: 'gestion.payout.status.' },
  { key: 'created', title: trans('gestion.payout.created') },
];

const payoutsData = computed(() => payoutStore.payouts.map((payout) => ({
  ...payout,
  amount: currency(payout.amount),
})));

const payoutsDataForMobile = computed(() => payoutStore.payouts.map((payout) => ({
  period: payout.created,
  status: payout.status,
  price: currency(payout.amount),
  object: payout.object,
})));

payoutStore.setPayoutsData(window.initialState.payouts);
accountStore.setStripeAccountStatus(window.initialState.stripe_account_status);

const accountStatus = computed(() => getAccountStatus(accountStore.stripeAccountStatus));

// @TODO Centralize in pinia store, see https://bureaux-a-partager.atlassian.net/browse/MATCH-9839
const isMobile = ref(false);

const checkIsMobile = () => {
  isMobile.value = window.BREAKPOINTS.isMobile;
};

onMounted(() => {
  checkIsMobile();
  window.addEventListener('resize', checkIsMobile);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', checkIsMobile);
});
</script>

<template>
  <div class="payouts">
    <div class="payouts__content">
      <div class="payouts__header">
        <div class="payouts__header-title">
          {{ trans('user_menu.payouts') }}
        </div>
      </div>
      <StripeSoonLimited v-if="STRIPE_LIMITED.includes(accountStore.stripeAccountStatus)" />
      <template v-if="payoutsData.length > 0">
        <SimpleTable
          v-if="!isMobile"
          :data="payoutsData"
          prefix="payouts"
          :headers="headers"
        />
        <SimpleTableMobile
          v-if="isMobile"
          :data="payoutsDataForMobile"
          prefix="payouts"
        />
      </template>
      <EmptyCardManager
        v-if="payoutsData.length === 0"
        :status="accountStore.stripeAccountStatus"
      >
        <template #ready>
          <CardEmptyTable
            logo="ph_coins_blue"
            :title="trans('gestion.payout.empty.title')"
            :subtitle="trans('gestion.payout.empty.title')"
            :status="accountStatus"
          />
        </template>
      </EmptyCardManager>
    </div>
  </div>
</template>
